import React, { useEffect } from 'react';
import { Pressable, StyleSheet, Text, View, type ViewStyle } from 'react-native';

import { useAuth } from '../../contexts/AuthContext';
import { useSampleData } from '../../contexts/SampleDataContext';
import { navigateToAuth } from '../../core/navigation/navigationRef';
import { colors, typography } from '../../core/theme/tokens';
import { MainTabNavigator } from '../Main/navigation/MainTabNavigator';
import { MarketingBackBar } from './MarketingBackBar';

/**
 * Isolated sample-data route. Not the app’s front door.
 */
export function ExploreScreen() {
  const { isAuthenticated } = useAuth();
  const { enterSampleMode } = useSampleData();

  useEffect(() => {
    enterSampleMode();
  }, [enterSampleMode]);

  return (
    <View style={styles.root}>
      <MarketingBackBar
        title="Sample"
        right={
          isAuthenticated ? undefined : (
            <Pressable
              accessibilityRole="button"
              accessibilityLabel="Sign in"
              onPress={navigateToAuth}
              style={({ pressed }) => [styles.signIn, pressed && styles.pressed]}
            >
              <Text style={styles.signInText}>Sign in</Text>
            </Pressable>
          )
        }
      />
      <View style={styles.main}>
        <MainTabNavigator />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    backgroundColor: colors.background,
  },
  signIn: {
    minHeight: 44,
    minWidth: 64,
    justifyContent: 'center',
    alignItems: 'flex-end',
  } as ViewStyle,
  signInText: {
    ...typography.body,
    fontSize: 17,
    fontWeight: '600',
    color: colors.accent,
  },
  main: {
    flex: 1,
    minHeight: 0,
  },
  pressed: {
    opacity: 0.8,
  },
});
